import React, { useState, useEffect } from 'react';

const IMG = {
  heroAcero: 'https://customer-assets-4nw71qhi.emergentagent.net/job_4cdae0ca-9c75-4bc0-a101-39471645aaff/artifacts/0iynbogo_43B78FAA-A7A8-4406-8D98-E3682FEF4CA8.jpeg',
};

const HeroSection = ({ loadingComplete }) => {
  const [animate, setAnimate] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  useEffect(() => {
    if (loadingComplete) {
      const t = setTimeout(() => setAnimate(true), 100);
      return () => clearTimeout(t);
    }
  }, [loadingComplete]);

  const words = ['No', 'purificamos', 'agua.', 'La', 'creamos.'];

  return (
    <section
      id="hero"
      data-testid="hero-section"
      style={{
        background: '#F5F5F7',
        height: isMobile ? 'auto' : '100vh',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        overflow: 'hidden',
        position: 'relative',
        paddingTop: isMobile ? '80px' : '0',
      }}
    >
      {/* Left column — text */}
      <div style={{
        width: isMobile ? '100%' : '50%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: isMobile ? '48px 24px 40px' : '0 clamp(32px, 5vw, 80px)',
        position: 'relative',
        zIndex: 2,
      }}>
        <div
          data-testid="hero-label"
          style={{
            fontFamily: 'Inter, sans-serif', fontWeight: 300, fontSize: '11px',
            letterSpacing: '0.14em', color: '#6B6B6B', textTransform: 'uppercase',
            marginBottom: '32px',
            opacity: animate ? 1 : 0,
            transition: 'opacity 400ms ease',
            transitionDelay: '0ms',
          }}
        >
          Agua pura desde el aire
        </div>

        <h1 style={{
          fontFamily: 'Inter, sans-serif', fontWeight: 800,
          fontSize: 'clamp(40px, 5.5vw, 92px)',
          letterSpacing: '-0.03em', color: '#0A0A0A',
          margin: '0 0 24px 0', lineHeight: 1.05,
        }}>
          {words.map((word, i) => (
            <span
              key={i}
              style={{
                display: 'inline-block',
                opacity: animate ? 1 : 0,
                transform: animate ? 'translateY(0)' : 'translateY(30px)',
                transition: 'opacity 400ms ease, transform 400ms ease',
                transitionDelay: `${i * 100}ms`,
                marginRight: '0.25em',
                willChange: 'transform',
              }}
            >
              {word}
            </span>
          ))}
        </h1>

        <p style={{
          fontFamily: 'Inter, sans-serif', fontWeight: 200, fontSize: '20px',
          letterSpacing: '0.06em', color: '#6B6B6B',
          margin: '0 0 48px 0',
          opacity: animate ? 1 : 0,
          transform: animate ? 'translateY(0)' : 'translateY(20px)',
          transition: 'opacity 400ms ease, transform 400ms ease',
          transitionDelay: '800ms',
          willChange: 'transform',
        }}>
          Edición Limitada · 999 unidades · Generación atmosférica inteligente.
        </p>

        <button
          className="hero-cta"
          onClick={() => document.getElementById('compra')?.scrollIntoView({ behavior: 'smooth' })}
          data-testid="hero-cta-button"
          style={{
            alignSelf: 'flex-start',
            opacity: animate ? 1 : 0,
            transition: 'opacity 300ms ease, background 300ms ease, color 300ms ease',
            transitionDelay: '800ms',
          }}
        >
          Descubrir ETERNA
        </button>
      </div>

      {/* Right column — image */}
      <div
        style={{
          width: isMobile ? '100%' : '50%',
          height: isMobile ? '70vw' : '100vh',
          position: 'relative',
          overflow: 'hidden',
          background: '#F5F5F7',
        }}
      >
        <img
          src={IMG.heroAcero}
          alt="ETERNA WATER — Generador Atmosférico de Agua"
          data-testid="hero-image"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            objectPosition: 'center bottom',
            mixBlendMode: 'multiply',
            opacity: animate ? 1 : 0,
            transform: animate ? 'translateY(0)' : 'translateY(50px)',
            transition: 'opacity 900ms ease-out, transform 900ms ease-out',
            transitionDelay: '600ms',
            willChange: 'transform',
            background: 'transparent',
            border: 'none',
          }}
        />
      </div>
    </section>
  );
};

export default HeroSection;
